// extracted by mini-css-extract-plugin
module.exports = {"nav":"Nav_nav__l7I_R","negative":"Nav_negative__RVSbj","mobile":"Nav_mobile__ynXyo","footer":"Nav_footer__lWMS9"};